import { SKYNET_INTERNAL_COMPANY_ID } from 'app/auth';
import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { KNOWLEDGE_ITEMS_ACTION_TYPE } from '../actions';

const enrichWithIsGlobal = item => ({
  ...item,
  isGlobal: item.companyId === SKYNET_INTERNAL_COMPANY_ID,
});

const initialState = {
  knowledgeItems: [],
};

const knowledgeItemsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case KNOWLEDGE_ITEMS_ACTION_TYPE.GET_KNOWLEDGE_ITEMS:
        draft.knowledgeItems = payload.map(enrichWithIsGlobal);
        break;

      case KNOWLEDGE_ITEMS_ACTION_TYPE.CREATE_KNOWLEDGE_ITEM:
        draft.knowledgeItems = [...state.knowledgeItems, enrichWithIsGlobal(payload)];
        break;

      case KNOWLEDGE_ITEMS_ACTION_TYPE.UPDATE_KNOWLEDGE_ITEM:
        draft.knowledgeItems = state.knowledgeItems.map(item =>
          item.id === payload.id ? enrichWithIsGlobal(payload) : item,
        );
        break;

      case KNOWLEDGE_ITEMS_ACTION_TYPE.DELETE_KNOWLEDGE_ITEM:
        draft.knowledgeItems = state.knowledgeItems.filter(({ id }) => id !== payload);
        break;

      case KNOWLEDGE_ITEMS_ACTION_TYPE.TOGGLE_KNOWLEDGE_ITEM_EXCLUSION: {
        const { knowledgeItemId, isExcluded } = payload;
        const itemIndex = state.knowledgeItems.findIndex(({ id }) => id === knowledgeItemId);

        if (itemIndex >= 0) {
          draft.knowledgeItems[itemIndex].isExcluded = isExcluded;
        }

        break;
      }

      case KNOWLEDGE_ITEMS_ACTION_TYPE.RESET_KNOWLEDGE_ITEMS_STATE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default knowledgeItemsReducer;
